import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React from 'react';
import { TaskStatusFilter } from '../../../types/Task';
import { appZIndex } from '../../../styles/zIndex';

export type TaskStatusAccountFilter = TaskStatusFilter | 'all';

interface Props {
  value: TaskStatusAccountFilter;
  onChange: (newStatus: TaskStatusAccountFilter) => void;
}

const AccountTaskFilter: React.FC<Props> = ({ value, onChange }) => {
  const handleChange = (e: SelectChangeEvent) => {
    onChange(e.target.value as TaskStatusAccountFilter);
  };

  return (
    <Select
      size="small"
      value={value}
      onChange={handleChange}
      sx={{ minWidth: 150 }}
      MenuProps={{
        sx: {
          zIndex: appZIndex.drawerPopup,
        },
      }}
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value={TaskStatusFilter.ACTIVE}>Active</MenuItem>
      <MenuItem value={TaskStatusFilter.NOT_STARTED}>Not Started</MenuItem>
      <MenuItem value={TaskStatusFilter.READY}>Ready</MenuItem>
      <MenuItem value={TaskStatusFilter.IN_PROGRESS}>In Progress</MenuItem>
      <MenuItem value={TaskStatusFilter.ON_HOLD}>On Hold</MenuItem>
      <MenuItem value={TaskStatusFilter.OVERDUE}>Overdue</MenuItem>
      <MenuItem value={TaskStatusFilter.COMPLETED}>Completed</MenuItem>
    </Select>
  );
};

export default AccountTaskFilter;
